var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "m13.28 12.53-3.75 3.75a.75.75 0 1 1-1.06-1.06l2.47-2.47H2.25a.75.75 0 1 1 0-1.5h8.69L8.47 8.78a.75.75 0 0 1 1.06-1.06l3.75 3.75a.747.747 0 0 1 0 1.06M18.75 3h-6a.75.75 0 1 0 0 1.5H18v15h-5.25a.75.75 0 1 0 0 1.5h6a.75.75 0 0 0 .75-.75V3.75a.75.75 0 0 0-.75-.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingIn);
export default __webpack_public_path__ + "static/media/SingIn.a194fa98dacc7f528072d3b3319b7702.svg";
export { ForwardRef as ReactComponent };